module.exports = __webpack_public_path__ + "static/img/4.6ea9d3b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/4.png
// module id = 3W/7
// module chunks = 0